/*import React, { useState, useEffect } from 'react';

const words = [
  'Desoxiribonucleico', 'SVG', 'Animation', 'Clickable', 'Responsive',
  'Grid', 'Layout', 'Design', 'Interactive', 'Dynamic',
  'Tailwind', 'CSS', 'JavaScript', 'TypeScript', 'Component',
  'State', 'Effect', 'Hook', 'Render', 'Props',
  'Context', 'Redux', 'Router', 'API', 'Fetch',
  'Async', 'Promise', 'Function', 'Class', 'Module',
  'Import', 'Export', 'Default', 'Named', 'As',
  'Const', 'Let', 'Var', 'Arrow', 'Callback',
  'Closure', 'Scope', 'This', 'Bind', 'Apply',
  'Call', 'Prototype', 'Inherit', 'Extend', 'Super'
];

export default function DLOC_INF() {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % words.length);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  const handleClick = (word: string) => {
    alert(`You clicked: ${word}`);
  };

  const columns = 4;
  const rows = 10;
  const rectWidth = 120;
  const rectHeight = 60;
  const gap = 5;

  const svgWidth = columns * rectWidth + (columns - 1) * gap;
  const svgHeight = rows * rectHeight + (rows - 1) * gap;

  return (
    <div className="w-full max-w-3xl mx-auto p-4 bg-sky-100 rounded-lg">
      <svg
        width="100%"
        height="100%"
        viewBox={`0 0 ${svgWidth} ${svgHeight}`}
        preserveAspectRatio="xMidYMid meet"
      >
        {words.map((word, index) => {
          const row = Math.floor(index / columns);
          const col = index % columns;
          const x = col * (rectWidth + gap);
          const y = row * (rectHeight + gap);
          const isActive = activeIndex === index;

          return (
            <g key={word} onClick={() => handleClick(word)}>
              <rect
                x={x}
                y={y}
                width={rectWidth}
                height={rectHeight}
                fill={isActive ? '#4CAF50' : 'transparent'}
                className="transition-all duration-300 ease-in-out cursor-pointer"
              />
              <text
                x={x + rectWidth / 2}
                y={y + rectHeight / 2}
                textAnchor="middle"
                dominantBaseline="middle"
                fill={isActive ? 'white' : '#333333'}
                className={`text-sm font-bold select-none cursor-pointer ${
                  isActive ? '' : 'hover:text-blue-600'
                }`}
              >
                {word}
              </text>
            </g>
          );
        })}
      </svg>
    </div>
  );
}*/

import {
  Box,
  Typography,
  Paper,
  Grid,
  TextField,
  Stack,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { useEffect, useState, useMemo, useRef } from "react";
import { numeroAleatorioObtener } from "../../../../../utils/generals";

// Función para dividir las palabras en columnas

function WordHeader({ words, find = [] }) {
  console.log(words, find);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isFond = (word) => {
    return find.includes(word);
  };
  return (
    <Box
      sx={{
        py: { xs: 1.5, sm: 2 },
        px: { xs: 1, sm: 2 },
        width: "100%",
        overflow: "hidden",
        borderBottom: "1px solid #e0e0e0",
      }}
    >
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={{ xs: 0.5, sm: 1, md: 2 }}
        alignItems={{ xs: "flex-start", sm: "center" }}
        sx={{
          maxWidth: "lg",
          mx: "auto",
          width: "100%",
        }}
      >
        <Typography
          variant={isSmallScreen ? "subtitle1" : "h6"}
          component="h1"
          sx={{
            color: "black",
            fontWeight: 500,
            whiteSpace: "nowrap",
            fontSize: { xs: "0.9rem", sm: "1rem", md: "1.1rem" },
          }}
        >
          Palabras a buscar:
        </Typography>
        <Stack
          direction="row"
          spacing={{ xs: 1, sm: 1.5, md: 2 }}
          sx={{
            flexWrap: "wrap",
            justifyContent: { xs: "flex-start", sm: "flex-start" },
            alignItems: "center",
          }}
        >
          {words.map((word, index) => (
            <Typography
              key={index}
              variant={isSmallScreen ? "body2" : "body1"}
              sx={{
                color: isFond(word) ? "#000000" : "#999",
                fontWeight: isFond(word) ? "bold" : 400,
                fontSize: { xs: "0.8rem", sm: "0.9rem", md: "1rem" },
                my: 0.5,
              }}
            >
              {word}
            </Typography>
          ))}
        </Stack>
      </Stack>
    </Box>
  );
}

export default function DLOC_INF_DLOC_PAL_SIM({ exercise, isRunning, velocity, isSIM, onAdditionalData }) {
  const isClick = useRef(0)
  const [allWords, setAllWords] = useState(
    exercise.content.split(",").reduce(function (a, b) {
      if (a.indexOf(b) < 0) a.push(b);
      return a;
    }, [])
  );
  const [columns, setColumns] = useState([[], [], []]);
  const wordsRef = useRef([]);
  const selectedWords = useRef([]);
  const findWords = useRef([]);

  const [gameState, setGameState] = useState({
    findWords: [],
    numAcertadas: 0,
    numErros: 0,
  });

  const minWordsPerColumn = exercise.lineas; // Mínimo de palabras por columna
  const numColumnas = parseInt(exercise.columnas);
  const numPalabras = parseInt(numColumnas * minWordsPerColumn);

  let velocidad = (1000 / velocity) * 60;
  velocidad = velocidad - 1000 / 60;

  const splitIntoColumns = (
    words: string[],
    minWordsPerColumn: number
  ): string[][] => {
    const totalWords = words.length;
    const columnCount = Math.floor(totalWords / minWordsPerColumn);
    const columns: string[][] = Array.from({ length: columnCount }, () => []);

    words.forEach((word, index) => {
      columns[index % columnCount].push(word);
    });

    return columns;
  };

  const randomArray = (array, numSel) => {
    let myArray = [...array];

    let cuatroRandom = [];
    let posicionesElegidas = [];
    let i, j, r, c;
    for (i = 0; i < numSel; i++) {
      r =
        Math.floor(
          Math.random() * (myArray.length - posicionesElegidas.length)
        ) + 1;
      c = 0;
      j = 0;
      do if (posicionesElegidas.indexOf(j++) == -1) c++;
      while (c < r);
      j--;
      cuatroRandom.push(myArray[j]);
      posicionesElegidas.push(j);
    }
    return cuatroRandom;
    //return posicionesElegidas();
  };

  const defineColumns = () => {
    const shuffledWords = [...allWords].sort(() => Math.random() - 0.5);
    const arrayPalabras = shuffledWords.slice(0, numPalabras);

    const columns = splitIntoColumns(arrayPalabras, minWordsPerColumn);
    wordsRef.current = arrayPalabras;
    setColumns(columns);
    selectedWords.current = randomArray(arrayPalabras, isSIM ? 1 : 5);
    console.log(gameState)
    setGameState({
      ...gameState,
      findWords: [],
    });
    isClick.current = 0
  };

 
  const workClick = (word) => {
    if (isClick.current == 0){
      isClick.current = 1;
      let newErros = gameState.numErros;
      let numAcertadasNew = gameState.numAcertadas;
      let newfindWords = gameState.findWords;
      if (selectedWords.current.includes(word)) {
        if (!gameState.findWords.includes(word)) {
          numAcertadasNew += 1;
          newfindWords.push(word);
        }
        
      } else {
        newErros += 1;
    
      }

      setGameState({
        numErros: newErros,
        numAcertadas: numAcertadasNew,
        findWords: newfindWords,
      });
      onAdditionalData({
        numErros: newErros,
        numAcertadas: numAcertadasNew,
      })
      
    }
  };

  useEffect(() => {
    if (gameState.findWords.length == selectedWords.current.length && selectedWords.current.length > 0) {
      setTimeout(() => {
        defineColumns();
      }, 1200);
    } else {
      isClick.current = 0
    }
  }, [selectedWords.current, gameState.numAcertadas, gameState.findWords, gameState.numErros])

  useEffect(() => {
    if (isRunning) defineColumns();
  }, [isRunning]);

  return (
    <>
      <Paper elevation={0} sx={{ p: 0.5, width: "100%" }}>
        <WordHeader words={selectedWords.current} find={gameState.findWords} />
      </Paper>
      <Box
        sx={{
          width: "100%",
          height: "auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          overflow: "hidden",
          background: "#ffffff",
        }}
      >
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: `repeat(auto-fit, minmax(100px, 1fr))`,
            gap: "1%",
            width: "100%",
            height: "100%",
            maxHeight: "100%",
            overflow: "hidden",
          }}
        >
          {columns.map((column, colIndex) => (
            <Box
              key={colIndex}
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                height: "100%",
              }}
            >
              {column.map((word, rowIndex) => {
                const wordIndex = colIndex * minWordsPerColumn + rowIndex;
                return (
                  <Typography
                    onClick={() => {
                      workClick(word);
                    }}
                    key={`${colIndex}-${rowIndex}`}
                    sx={{
                      color: gameState.findWords.includes(word)
                        ? "#000000"
                        : "#999",
                      padding: "3%",
                      fontSize: "clamp(0.8rem, 1.5vw, 1.5rem)",
                      lineHeight: 1.2,
                      position: "relative",
                      textAlign: "center",
                      flex: 1,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      fontWeight: gameState.findWords.includes(word)
                        ? "#000000"
                        : "#999",
                    }}
                  >
                    {word}
                  </Typography>
                );
              })}
            </Box>
          ))}
        </Box>
      </Box>
      <Paper elevation={2} sx={{ mt: 1, p: 1, width: "100%" }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={5}>
            <TextField
              label="Palabras econtradas"
              size="small"
              value={gameState.numAcertadas}
              fullWidth
              InputProps={{ readOnly: true }}
            />
          </Grid>
          <Grid item xs={12} sm={2}></Grid>
          <Grid item xs={12} sm={5}>
            <TextField
              size="small"
              label="Errores"
              value={gameState.numErros}
              fullWidth
              InputProps={{ readOnly: true }}
            />
          </Grid>
        </Grid>
      </Paper>
    </>
  );
}
